<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { PageHeader, NextButton },
  data() {
    return { inboxName: '', apikey: '', login: '', password: '', sender: '', partnerId: '556854' };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  methods: {
    async createChannel() {
      const hasAuth = this.apikey || (this.login && this.password);
      if (!this.inboxName.trim() || !hasAuth) {
        useAlert('Укажите название и API-ключ (или логин+пароль) SMSC');
        return;
      }
      try {
        const inbox = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName.trim(),
          channel: {
            type: 'smsc',
            phone_number: this.sender || null,
            provider_config: {
              apikey: this.apikey,
              login: this.login,
              password: this.password,
              sender: this.sender,
              partner_id: this.partnerId,
            },
          },
        });
        router.replace({
          name: 'settings_inboxes_add_agents',
          params: { page: 'new', inbox_id: inbox.id },
        });
      } catch (error) {
        useAlert(error?.response?.data?.message || 'Не удалось создать источник SMSC');
      }
    },
  },
};
</script>

<template>
  <div class="w-full h-full col-span-6 p-6">
    <PageHeader
      header-title="СМС через SMSC.ru"
      header-content="Источник для отправки/приёма СМС через сервис SMSC.ru."
    />
    <form class="flex flex-col flex-wrap mx-0" @submit.prevent="createChannel">
      <div class="flex-shrink-0 flex-grow-0">
        <label>Название инбокса<input v-model="inboxName" type="text" placeholder="Например: СМС SMSC" /></label>
      </div>
      <div class="flex-shrink-0 flex-grow-0">
        <label>API-ключ SMSC (рекомендуется, как в MRES)<input v-model="apikey" type="text" placeholder="apikey из ЛК SMSC" /></label>
      </div>
      <div class="flex-shrink-0 flex-grow-0">
        <label>Логин SMSC (альтернатива API-ключу)<input v-model="login" type="text" /></label>
      </div>
      <div class="flex-shrink-0 flex-grow-0">
        <label>Пароль (или MD5-хеш)<input v-model="password" type="text" /></label>
      </div>
      <div class="flex-shrink-0 flex-grow-0">
        <label>Имя отправителя (sender)<input v-model="sender" type="text" placeholder="stomcomfort" /></label>
      </div>
      <div class="flex-shrink-0 flex-grow-0">
        <label>Партнёрский ID (pp)<input v-model="partnerId" type="text" placeholder="556854" /></label>
      </div>
      <div class="w-full mt-4">
        <NextButton :is-loading="uiFlags.isCreating" type="submit" solid blue label="Создать источник" />
      </div>
    </form>
  </div>
</template>
